import { Toaster } from "sonner";
import { MotionConfig } from "framer-motion";
import { ModalProvider } from "@/context/ModalContext";
import { ContactModal } from "@/components/modal/ContactModal";
import { InstallGuideModal } from "@/components/modal/InstallGuideModal";
import { Header } from "@/components/sections/Header";
import { Hero } from "@/components/sections/Hero";
import { Logos } from "@/components/sections/Logos";
import { PainPoints } from "@/components/sections/PainPoints";
import { OneMenu } from "@/components/sections/OneMenu";
import { Stats } from "@/components/sections/Stats";
import { Features } from "@/components/sections/Features";
import { DashboardPreview } from "@/components/sections/DashboardPreview";
import { Integrations } from "@/components/sections/Integrations";
import { Modules } from "@/components/sections/Modules";
import { Pricing } from "@/components/sections/Pricing";
import { FAQ } from "@/components/sections/FAQ";
import { CTA } from "@/components/sections/CTA";
import { Footer } from "@/components/sections/Footer";
import { Apps } from "@/components/sections/Apps";

export default function App() {
  return (
    // reducedMotion="user" makes every framer-motion animation on the page
    // honour the visitor's OS "reduce motion" setting.
    <MotionConfig reducedMotion="user">
      <ModalProvider>
        <div className="min-h-screen">
          <Header />
          <main>
            {/* The problem, then the mechanic that solves it, then the proof. */}
            <Hero />
            <Logos />
            <PainPoints />
            <OneMenu />
            <Stats />
            <Features />
            <DashboardPreview />
            <Integrations />
            <Modules />
            <Pricing />
            <FAQ />
            <CTA />
            <Apps />
          </main>
          <Footer />
        </div>
        <ContactModal />
        <InstallGuideModal />
        <Toaster position="top-center" richColors />
      </ModalProvider>
    </MotionConfig>
  );
}
